import {
  ajioclone,
  Skinstore,
  AICodeConverter,
  GlamGrab,
  InjuryReport,
  ZuseCode,
  BuildAI,
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: BuildAI,
    title: "Build-AI",
    info: "An AI-powered web development platform that enables developers to create, edit, and deploy web applications effortlessly with the assistance of artificial intelligence.",
    TechStack:
      "TypeScript | React.js | Next.js | Node.js | Express.js | OpenAI API | PostgreSQL | MongoDB",
    codeLink: "https://github.com/Abhii-07/Build-AI",
    liveLink: "https://build-ai-mu.vercel.app/",
  },
  // {
  //   id: 3,
  //   image: ajioclone,
  //   title: "Ajio-Clone",
  //   info: "An E-commerce website for purchasing clothings & footwears",
  //   TechStack: "HTML5 | CSS3 | JavaScript",
  //   codeLink: "https://github.com/Abhii-07/Ajio-Clone",
  //   liveLink: "https://rad-wisp-02436f.netlify.app",
  // },
  {
    id: 3,
    image: AICodeConverter,
    title: "AI Code Converter",
    info: "Web application to convert code from one programming language to another using the OPENAI API.",
    TechStack: "Java | Spring Boot | ReactJS | OpenAI API",
    codeLink: "https://github.com/Abhii-07/AI-Code-Converter",
    liveLink: "https://ai-code-converter-xi.vercel.app/",
  },
  {
    id: 4,
    image: GlamGrab,
    title: "GlamGrab",
    info: "An e-commerce website inspired by the popular website, AJIO.com.",
    TechStack: "JavaScript | ReactJS ",
    codeLink: "https://github.com/Abhii-07/React-ecommerce-app",
    liveLink: "https://glamgrab-react.vercel.app/",
  },
  {
    id: 5,
    image: InjuryReport,
    title: "Injury Reporting System",
    info: "Web application that can be used by an organization (such as the police) to easily record and track the injuries reported by a person",
    TechStack: "NodeJs | NextJS | ExpressJS | MongoDB | Clerk | Canvas2D ",
    codeLink: "https://github.com/Abhii-07/injury-report-app-nextjs",
    liveLink: "https://injury-report-app-nextjs.vercel.app/",
  },
  {
    id: 6,
    image: ZuseCode,
    title: "ZuseCode - Web IDE",
    info: "ZuseCode is a powerful, web-based Integrated Development Environment (IDE) designed to streamline the coding process. It offers features such as code editing, file management, terminal access.",
    TechStack: "React | Node.js | Express.js | Socket.IO | Gemini API",
    codeLink: "https://github.com/Abhii-07/ZuseCode",
    liveLink: "https://zuse-code.vercel.app/",
  },
];
